/**
 * API 接口路径配置
 * 参考 tv-linux 项目的 base.js
 */

export const API_PATHS = {
  // 首页频道页
  GetHomePage: 'trpc.video_app_international.trpc_home_page.HomePage/GetHomePage',
  // 实时搜索
  RPCSmartBox: 'trpc.video_app_international.trpc_kt_search.TVSearch/RPCSmartBox',
  // 搜索
  RPCSearch: 'trpc.video_app_international.trpc_search.Search/RPCSearchNew',
  // 详情页
  getDetail: 'trpc.video_app_international.trpc_d_video_detail.TrpcDVideoDetail/GetDetailPage',
  // 列表页/筛选页
  GetFilterPage: 'trpc.video_app_international.trpc_filter_page.FilterPage/GetFilterPage',
  // 搜索热榜
  GetSearchHotList: 'trpc.video_app_international.trpc_kt_search.TVSearch/RPCRank',
  // 观看历史
  GetRPCQueryHistory: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCQueryHistory',
  // 观看历史海报
  GetRPCQueryHistoryUiData: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCQueryHistoryUiData',
  // GetVideoInfo，判断是否需要上传历史记录
  GetVideoInfo: 'trpc.video_app_international.trpc_union_proxy.TrpcUnionProxy/GetVideoInfo',
  // 获取历史记录对应的cid封面图
  GetCoverInfo: 'trpc.video_app_international.trpc_union_proxy.TrpcUnionProxy/GetCoverInfo',
  // 同步服务器时间
  RPCSyncTime: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCSyncTime',
  // 观看历史海报上报删除
  RPCReportHistory: 'trpc.video_app_international.trpc_history_write.HistoryWrite/RPCReportHistory',
  // 观看历史海报上报全部删除
  RPCReportDelAllHistory: 'trpc.video_app_international.trpc_history_write.HistoryWrite/RPCReportDelAllHistory',
  // 扫码登录
  GetQrInfo: 'video_i18n.QrWrite/GetQrInfo',
  // 扫码获取授权状态
  AuthPoll: 'video_i18n.QrPoll/AuthPoll',
  // 发送验证码（OTP）
  SendOtp: 'trpc.video_app_international.trpc_otp.TrpcOtp/SendOtp',
  // 验证验证码（OTP）
  VerifyOtp: 'trpc.video_app_international.trpc_otp.TrpcOtp/VerifyOtp',
  // 查询账号状态 1账号格式非法；2跳注册；3跳重置密码；4跳登录
  checkAccount: 'trpc_account_check.AccountCheck/GetState',
  // 登录
  phoneLogin: 'trpc_web_login.WebLogin/Login',
  // 获取会员信息
  UserVIPInfo: 'trpc.video_app_international.trpc_user_info.TrpcUserInfo/UserVIPInfo',
  // 退出登录
  Logout: 'trpc_web_login.WebLogin/Logout',
  // 票据续期
  ReNew: 'trpc_web_login.WebLogin/ReNew',
  // 获取付费二维码
  paidCode: 'fcgi-bin/hw_comm_cgi?name=spp_inter_tv_shorturl_new&cmd=25523&otype=xjson',
  // 海外TV端预鉴权
  ProcessTVPreAuth: 'fcgi-bin/hw_comm_cgi?name=spp_inter_tv_pre_auth&otype=xjson',
  // 直播详情
  liveDetail: 'trpc.video_app_international.trpc_live_detail.LiveDetail/GetLiveDetail',
  // 直播
  liveStreaming: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetLivePoll',
  // 直播多机位
  liveMultiCamera: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetMultiCamera',
  // 剧集断点续播
  lastPlay: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCQuerySingleHistory',
  // 观看历史上报
  historyReport: 'trpc.video_app_international.trpc_history_write.HistoryWrite/RPCReportHistory',
  // wetv会员开通
  CreateGuidIntl: 'rpc/trpc.long_link_group.inter_long_link_intl.InterLongLinkIntl/CreateGuidIntl',
  // 用户的跨端支付结果轮询
  GetMsgIntl: 'rpc/trpc.long_link_group.inter_long_link_intl.InterLongLinkIntl/GetMsgIntl',
  // 详情页定位与翻页接口
  getDetailPage: 'trpc.video_app_international.trpc_d_video_detail.TrpcDVideoDetail/GetDetailVideoList',
  // 错误日志上报
  UploadLog: 'trpc.video_app_international.trpc_aisee_hook.AiSee/UploadLog',
  // 用户年龄信息提交
  UserInfoWrite: 'trpc.video_app_international.trpc_user_info.TrpcUserInfo/UserInfoWrite',
  // 获取用户信息
  GetUserInfo: 'trpc.video_app_international.trpc_user_info.TrpcUserInfo/UserInfoRead',
  // 年龄授权确认接口
  SetUserGrant: 'trpc.video_app_international.trpc_user_grant.TrpcUserGrant/RPCGrant',
  // 会员开通Astro侧验证账号信息
  CheckChannelAccount: 'trpc_identity_info.IdentityInfo/VerifyIdentity?video_appid=1200012',
  // 获取直播详情页数据
  GetLiveDetail: 'trpc.video_app_international.trpc_live_detail.LiveDetail/GetLiveDetail',
  // 直播轮询接口(轮询获取直播的状态)
  LivePoll: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetLivePoll',
  // 直播多机位轮询接口
  GetLiveMultiCamera: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetMultiCamera',
  // 频道页数据
  RPCUnChannelPageData: 'trpc.video_app_international.trpc_channel_data.ChannelData/RPCUnChannelPageData',
} as const;
